export const getCalendarRoute = (view, date) => {
  return `/calendar/${view}/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
}
